module.exports = __webpack_public_path__ + "img/10888_L.209542ac.png";